<template>
  <div>
    <a-modal
      :title="$t('page_business_maintenance')"
      :visible="visible"
      :confirm-loading="confirmLoading"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <ml-table
        :columns="columns"
        :dataSource="dataList"
        :pagination="pagination"
        :canChangeColWidth="true"
        rowKey="id"
        :scroll="{ y: tableScrollY }"
        :custom-row="rowClick"
        :selectRowKey="deviceId"
      >
      </ml-table>
      <ml-table
        :columns="columnsform"
        :dataSource="dataChildren"
        :canChangeColWidth="true"
        :scroll="{ y: tableScrollY }"
        :pagination="paginationForm"
      >
      </ml-table>
    </a-modal>
  </div>
</template>

<script>
import { MaintainProjectServiceProxy } from "@/service-proxies/app-v2/tpm.service-proxies";
const maintainProjectServiceProxy = new MaintainProjectServiceProxy();
// const columns = [
//   { title: "保养项目编码", dataIndex: "code", width: 200, ellipsis: true },
//   { title: "保养项目", dataIndex: "name", width: 200, ellipsis: true },
//   { title: "保养周期", dataIndex: "intervalTime", width: 100, ellipsis: true },
//   {
//     title: "保养预警",
//     dataIndex: "preWarningDays",
//     width: 100,
//     ellipsis: true,
//   },
//   { title: "备注", dataIndex: "remark", ellipsis: true },
// ];
// const columnsform = [
//   { title: "保养编码", dataIndex: "itemCode", width: 200, ellipsis: true },
//   { title: "保养项", dataIndex: "itemName", width: 200, ellipsis: true },
//   {
//     title: "保养要求",
//     dataIndex: "itemRequirement",
//     width: 200,
//     ellipsis: true,
//   },
//   { title: "备注", dataIndex: "itemRemark", ellipsis: true },
// ];
export default {
  props: ["typeList", "typeId", "visible", "maintenanceId"],
  data() {
    return {
      confirmLoading: false,
      // columns,
      // columnsform,
      tableScrollY: 300,
      dataList: [],
      dataChildren: [],
      selectedRowKeys: [],
      deviceId: "",
      pagination: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
      paginationForm: {
        total: 0,
        pageSize: 10,
        current: 1,
      },
    };
  },
  created() {
    this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage;
      this.queryMaintainProjectListPage();
    };
    this.paginationForm.onChange = (currentPage) => {
      this.paginationForm.current = currentPage;
      this.queryMaintainProjectItemListPage();
    };
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t("page_plan_maintenance_maintenance_items_code"),
          dataIndex: "code",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_business_maintenance"),
          dataIndex: "name",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_plan_maintenance_period"),
          dataIndex: "intervalTime",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_device_maintenance_warning"),
          dataIndex: "preWarningDays",
          width: 100,
          ellipsis: true,
        },
        { 
          title: this.$t("remark"), 
          dataIndex: "remark", 
          width: 100,
          ellipsis: true 
        },
      ];
    },
    columnsform() {
      return [
        {
          title: this.$t("page_plan_maintenance_code"),
          dataIndex: "itemCode",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_device_maintenance_items"),
          dataIndex: "itemName",
          width: 100,
          ellipsis: true,
        },
        {
          title: this.$t("page_plan_maintenance_requirements"),
          dataIndex: "itemRequirement",
          width: 100,
          ellipsis: true,
        },
        { 
          title: this.$t("remark"), 
          dataIndex: "itemRemark", 
          width: 100,
          ellipsis: true 
        },
      ];
    },
  },
  watch: {
    visible(val) {
      if (val && this.maintenanceId) {
        this.queryMaintainProjectListPage();
      }
    },
    selectedRowKeys: {
      handler(val) {
        if (val) {
          this.queryMaintainProjectItemListPage();
        }
      },
      immediate: true,
    },
  },
  methods: {
    // onSelectChange(selectedRowKeys, selectedRows) {
    //   this.selectedRowKeys = selectedRowKeys;
    //   // console.log(selectedRowKeys)
    // },
    handleOk(e) {
      this.confirmLoading = true;
      setTimeout(() => {
        this.$emit("closeMaintenance");
        this.confirmLoading = false;
      }, 2000);
    },
    handleCancel(e) {
      this.$emit("closeMaintenance");
    },
    async queryMaintainProjectListPage() {
      let result = await maintainProjectServiceProxy.queryMaintainProjectListPage(
        this.pagination.current,
        this.maintenanceId,
        this.pagination.pageSize
      );
      this.dataList = result.records;
      this.pagination.total = result.total;
      this.selectedRowKeys = [];
      if (this.dataList.length) {
        this.selectedRowKeys.push(this.dataList[0].id);
        this.deviceId = this.dataList[0].id;
      }
      // console.log("qqqq", this.dataList);
    },
    async queryMaintainProjectItemListPage() {
      let result = await maintainProjectServiceProxy.queryMaintainProjectItemListPage(
        this.paginationForm.current,
        this.selectedRowKeys,
        this.paginationForm.pageSize
      );
      this.dataChildren = result.records;
      this.paginationForm.total = result.total;
    },
    rowClick(record) {
      return {
        on: {
          click: (event) => {
            // console.log("aaaaaa", record);
            this.deviceId = record.id;
            this.selectedRowKeys = [];
            this.selectedRowKeys.push(record.id);
          },
        },
      };
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 1240px !important;
}
</style>